/**
 * Palette commune aux graphiques de repartition.
 *
 * Elle etait recopiee a l'identique dans `repartition-bar-horizontal` et
 * `repartition-bar-vertical`, chacun la degradant de son cote sur son propre
 * effectif. Deux cartes montrant les memes cultures en nombre different
 * donnaient donc deux couleurs a une meme culture.
 *
 * La palette va du vert sombre au jaune : l'ordre des couleurs est aussi
 * l'ordre de lecture des barres.
 */
export const PALETTE_REPARTITION = [
  '#027F5F', '#138659', '#238E53', '#33954D', '#449D47', '#54A441',
  '#64AB3B', '#74B335', '#84BA2F', '#94C229', '#A5C923', '#B5D11D',
  '#C5D817', '#D5DF11', '#E6E70A'
]

/**
 * Couleurs a donner a un ensemble d'elements, dans leur ordre d'affichage.
 *
 * En dessous de la taille de la palette, les teintes sont espacees pour couvrir
 * toute l'amplitude : quatre cultures prennent le vert le plus sombre, le
 * jaune, et deux intermediaires, plutot que les quatre premiers verts.
 *
 * @param {number} nombreElements nombre d'elements a colorer
 * @param {string[]} palette teintes disponibles, de la plus sombre a la plus claire
 * @returns {string[]} une couleur par element, dans l'ordre
 */
export function couleursPourEffectif (nombreElements, palette = PALETTE_REPARTITION) {
  const nombreTeintes = palette.length

  if (nombreElements >= nombreTeintes || nombreElements === 1) {
    return palette
  }

  return Array.from(
    { length: nombreElements },
    (_, index) => palette[Math.round((index * (nombreTeintes - 1)) / (nombreElements - 1))]
  )
}

/**
 * Couleur et rang de chaque code, a partir d'une liste de reference.
 *
 * C'est ce qui permet a une carte de reprendre les couleurs d'une autre : la
 * repartition des grandes cultures fait foi, les autres cartes s'y alignent au
 * lieu de recalculer leurs teintes sur leur propre sous-ensemble.
 *
 * @param {string[]} codesDeReference codes dans l'ordre de la carte de reference
 * @param {string[]} palette teintes disponibles
 * @returns {Object<string, {couleur: string, rang: number}>} indexe par code
 */
export function reperesParCode (codesDeReference, palette = PALETTE_REPARTITION) {
  if (codesDeReference == null) {
    return {}
  }

  const couleurs = couleursPourEffectif(codesDeReference.length, palette)

  return codesDeReference.reduce((reperes, code, rang) => {
    reperes[code] = { couleur: couleurs[rang], rang }

    return reperes
  }, {})
}
